import React from 'react';
import { XCircle, CheckCircle2, ArrowRight } from 'lucide-react';
import { Button } from './Button';
export function ProblemSection() {
  return <section className="py-14 px-4 bg-navy-900" data-id="element-158">
      <div className="max-w-3xl mx-auto" data-id="element-159">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-8" data-id="element-160">
          Se insegni inglese, conosci bene questa situazione...
        </h2>

        <div className="bg-red-900/20 border border-red-500/30 rounded-2xl p-6 mb-8" data-id="element-161">
          <ul className="space-y-4" data-id="element-162">
            {['Passi ore a cercare materiali sparsi e poco adatti alla tua classe.', 'Ogni settimana devi ricominciare da zero, senza un sistema organizzato.', 'Alla fine della giornata ti senti esausto — con la sensazione di non stare mai al passo.'].map((p, i) => <li key={i} className="flex items-start gap-3" data-id="element-163">
                <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-164" />
                <p className="text-gray-300 leading-relaxed" data-id="element-165">{p}</p>
              </li>)}
          </ul>
        </div>

        <div className="text-center mb-8" data-id="element-166">
          <h3 className="text-2xl font-bold text-gold-400 mb-3" data-id="element-167">
            Il MegaPack Inglese™ risolve tutto questo.
          </h3>
          <p className="text-gray-300" data-id="element-168">
            Centinaia di risorse organizzate, pronte all'uso, per ogni livello —
            da A1 a C1.
          </p>
        </div>

        <div className="bg-green-900/20 border border-green-500/30 rounded-2xl p-6" data-id="element-169">
          <ul className="space-y-3" data-id="element-170">
            {['Attività comunicative coinvolgenti per ogni livello', "Giochi didattici con istruzioni chiare e pronte all'uso", 'Lezioni strutturate passo dopo passo + strumenti di valutazione'].map((s, i) => <li key={i} className="flex items-start gap-3" data-id="element-171">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-172" />
                <p className="text-gray-200 leading-relaxed" data-id="element-173">{s}</p>
              </li>)}
          </ul>
        </div>

        <div className="text-center mt-8" data-id="element-174">
          <Button href="#offer" className="w-full sm:w-auto text-base px-8 py-4" data-id="element-175">
            <span className="flex items-center gap-2" data-id="element-176">
              Scopri l'offerta completa <ArrowRight className="w-5 h-5" data-id="element-177" />
            </span>
          </Button>
        </div>
      </div>
    </section>;
}